<template>
  <f7-page>
    <AppLayout>
      <template #main>
        <f7-navbar
          no-shadow
          :title="$t('common.offline')"
          back-link
          :back-link-show-text="false"
        ></f7-navbar>
        <div
          class="display-flex flex-direction-column justify-content-center"
          style="height: 100%"
        >
          <div class="text-align-center">
            <f7-block strong class="no-margin-top">
              <div class="offline-animation-wrapper margin-bottom">
                <img
                  src="/32x32.svg"
                  class="avocash-pulse-logo"
                  :alt="$t('common.a11y.appLogo')"
                />
                <f7-icon
                  ios="f7:wifi_slash"
                  md="material:signal_wifi_off"
                  size="24"
                  class="offline-overlay-badge"
                ></f7-icon>
              </div>
              <f7-block-title large class="margin-bottom">{{
                $t("common.noInternet")
              }}</f7-block-title>
              <p class="margin-bottom">{{ $t("common.checkConnection") }}</p>

              <f7-button
                fill
                round
                large
                color="red"
                @click="retryConnection"
                class="margin-bottom"
              >
                {{ $t("common.retry") }}
              </f7-button>

              <f7-link href="/" icon-f7="house_fill" class="display-block">
                {{ $t("common.goToHome") }}
              </f7-link>
            </f7-block>
          </div>
        </div>
      </template>
    </AppLayout>
  </f7-page>
</template>
<script setup>
import { f7 } from "framework7-vue";
import AppLayout from "@/components/common/AppLayout.vue";
import i18n from "@/js/i18n.js";
defineProps({
  f7route: Object,
  f7router: Object,
});

function retryConnection() {
  if (navigator.onLine) {
    window.location.reload();
  } else {
    f7.toast
      .create({
        text: i18n.global.t("common.stillOffline"),
        closeTimeout: 2000,
      })
      .open();
  }
}
</script>

<style scoped>
.offline-animation-wrapper {
  position: relative;
  display: inline-block;
  margin: 20px auto;
}

.avocash-pulse-logo {
  width: 80px;
  height: 80px;
  animation: avocash-pulse 2.5s infinite ease-in-out;
}

.offline-overlay-badge {
  position: absolute;
  bottom: 0;
  right: 0;
  background: var(--f7-theme-color-red, #ff3b30);
  color: #fff;
  border-radius: 50%;
  padding: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

@keyframes avocash-pulse {
  0%,
  100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.7;
  }
}
</style>
